// extracted by mini-css-extract-plugin
export default {"defaultLayout":"Layout_defaultLayout__ld4Rt","contentWrapper":"Layout_contentWrapper__j8i0M"};